<template>
  <hic-index-page header-height="6rem">
    <template slot="title">
      <header class="el-header sub-header" style="height: 3rem;">
        <div class="el-row is-justify-space-between is-align-middle el-row--flex">
          <div class="sub-title left"><span>导出：</span></div>
          <div class="right"></div>
        </div>
      </header>
    </template>

    <div class="export-container" v-loading="loading">
      <div class="modules-grid">
        <div class="module-card" v-for="(item, index) in modules" :key="index">
          <div class="module-title">{{ item.name }}</div>
          <div class="module-content">
            <template v-if="item.dateType === 'daterange'">
              <div style="line-height:3;text-align:center;">
                <!-- <el-date-picker v-model="item.dateRange" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
                  size="small" value-format="yyyy-MM-dd" /> -->
                <el-date-picker v-model="item.dateRange[0]" type="date" placeholder="开始日期" size="small" value-format="yyyy-MM-dd" style="width:140px" />
                &nbsp;&nbsp;-&nbsp;&nbsp;
                <el-date-picker v-model="item.dateRange[1]" type="date" placeholder="结束日期" size="small" value-format="yyyy-MM-dd" style="width:140px" />
                <br>
                <template v-if="item.name == '目标对象健康台账'">
                  <el-radio v-model="item.state" label="已入住">在院</el-radio>
                  <el-radio v-model="item.state" label="已离院">离院</el-radio>
                  <el-radio v-model="item.state" label="">全部</el-radio>
                </template>
              </div>
            </template>
            <template v-else-if="item.dateType === 'month'">
              <el-date-picker v-model="item.date" type="month" placeholder="选择月份" size="small" value-format="yyyy-MM" />
            </template>
            <template v-else>
              <el-select v-if="item.name == '求医汇总'" v-model="patient.curr" value-key="id" placeholder="请选择患者" clearable size="small" class="right-pad" filterable>
                <el-option v-for="item in patient.items" :key="item.id" :label="`${item.bedNo}：${item.patientName}`" :value="item" style="height: 3rem">
                  <el-badge :value="item.news" :hidden="!item.news" style="margin: 0.5rem 0">
                    <el-tag size="small" :type="item.news > 0 ? 'danger' : 'info'" class="right-pad">{{ item.bedNo }}</el-tag>
                  </el-badge>

                  <b>{{ item.patientName }}</b>
                  <span>{{ item.patientGender | dictText("Gender") }} {{ item.patientAge }}</span>
                </el-option>
              </el-select>
              <el-date-picker v-if="item.name == '求医汇总'" v-model="item.date" type="date" placeholder="选择日期" size="small" value-format="yyyy-MM-dd" style="width:140px" />
              <el-date-picker v-else v-model="item.date" type="date" placeholder="选择日期" size="small" value-format="yyyy-MM-dd" />
            </template>
            <el-button type="text" class="export-link" @click="handleExport(item)">导出</el-button>
          </div>
        </div>
      </div>
    </div>
  </hic-index-page>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  data() {
    return {
      loading: false,
      modules: [
        { name: "交接班记录表", date: "", dateType: "date", placeholder: "选择日期" },
        { name: "目标对象健康台账", dateRange: [], dateType: "daterange", state: '已入住', placeholder: ["开始日期", "结束日期"] },
        { name: "调床登记表", dateRange: [], dateType: "daterange", placeholder: ["开始日期", "结束日期"] },
        { name: "出所登记表", dateRange: [], dateType: "daterange", placeholder: ["开始日期", "结束日期"] },
        { name: "新入所登记台账表", dateRange: [], dateType: "daterange", placeholder: ["开始日期", "结束日期"] },
        { name: "外出就诊汇总表", date: "", dateType: "month", placeholder: "选择月份" },
        { name: "院外专家来中心会诊情况表", date: "", dateType: "month", placeholder: "选择月份" },
        { name: "会诊安排表", date: "", dateType: "date", placeholder: "选择日期" },
        { name: "求医汇总", date: "", dateType: "date", placeholder: "选择日期" },
      ],
      patient: {
        items: [],
        curr: null,
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    // 交接班记录表默认今天
    this.modules[0].date = this.$utils.Dt.today();
    // 目标对象健康台账默认今天
    this.modules[1].dateRange = [ '2025-09-01', this.$utils.Dt.today() ];
    // 调床登记表默认今天
    this.modules[2].dateRange = [ this.$utils.Dt.today(), this.$utils.Dt.today() ];
    // 出所登记表默认今天
    this.modules[3].dateRange = [ this.$utils.Dt.today(), this.$utils.Dt.today() ];
    // 新入所登记台账表默认今天
    this.modules[4].dateRange = [ this.$utils.Dt.today(), this.$utils.Dt.today() ];
    // 外出就诊汇总表默认当前月
    this.modules[5].date = this.$utils.Dt.today().substring(0, 7);
    // 院外专家来中心会诊情况表默认当前月
    this.modules[6].date = this.$utils.Dt.today().substring(0, 7);
    // 会诊安排表默认今天
    this.modules[7].date = this.$utils.Dt.today();
    // 求医汇总默认今天
    this.modules[8].date = this.$utils.Dt.today();

    api.Hospitalization.query({
      state: "已入住",
      pageIndexOnView: 1,
      pageSize: 9999,
      deptCode: this.user.deptCode,
      sort: "bedNo",
      asc: true,
    }).then((res) => {
      this.patient.items = res.items;
    });
  },
  methods: {
    // 获取班次时间范围
    getShiftTimeRange(dateStr) {
      // dateStr 格式：2026-01-02
      const date = new Date(dateStr);
      // 前一天
      const prevDate = new Date(date);
      prevDate.setDate(prevDate.getDate() - 1);
      const prevDateStr = this.$utils.Fmt.date(prevDate, "yyyy-MM-dd");
      // 返回 [前一天早上8点, 今天早上8点]
      return [
        `${prevDateStr} 08:00:00`,
        `${dateStr} 08:00:00`
      ];
    },
    handleExport(item) {
      if (item.dateType === 'daterange') {
        if (!item.dateRange || item.dateRange.length === 0 || !item.dateRange[0] || !item.dateRange[1]) {
          this.$message.warning("请先选择日期范围！");
          return;
        }
      } else {
        if (!item.date) {
          this.$message.warning("请先选择日期！");
          return;
        }
      }
      
      if (item.name == '求医汇总') {
        if (!this.patient.curr) {
          this.$message.warning('请选择患者！');
          
          return;
        }
      }

      let url = '';
      let params = {};
      switch (item.name) {
        case '交接班记录表':
          url = '/api/ip/exportLog/export'

          params.startTime = this.getShiftTimeRange(item.date)[0]//  "2024-01-28 00:00:01"
          params.endTime = this.getShiftTimeRange(item.date)[1] // "2026-03-16 23:59:59"

          break;
        case '目标对象健康台账':
          params.startDateSt = item.dateRange[0] + ' 00:00:00';
          params.startDateEd = item.dateRange[1] + ' 23:59:59';

          url = `/api/ip/export/patient?state=${item.state}&startDateSt=${params.startDateSt}&startDateEd=${params.startDateEd}`

          break;
        case '调床登记表':
          params.createDateStart = item.dateRange[0] + ' 00:00:00';
          params.createDateEnd = item.dateRange[1] + ' 23:59:59';

          url = `/api/ip/export/bed?createDateStart=${params.createDateStart}&createDateEnd=${params.createDateEnd}`

          break;
        case '出所登记表':
          params.endDateSt = item.dateRange[0] + ' 00:00:00';
          params.endDateEd = item.dateRange[1] + ' 23:59:59';

          url = `/api/ip/export/checkout?endDateSt=${params.endDateSt}&endDateEd=${params.endDateEd}`

          break;
        case '新入所登记台账表':
          params.startDateSt = item.dateRange[0] + ' 00:00:00';
          params.startDateEd = item.dateRange[1] + ' 23:59:59';

          url = `/api/ip/export/checkin?startDateSt=${params.startDateSt}&startDateEd=${params.startDateEd}`

          break;
        case '外出就诊汇总表':
          params.month = item.date;

          url = `/api/ip/export/outmedical?month=${params.month}`

          break;
        case '院外专家来中心会诊情况表':
          params.month = item.date;

          url = `/api/ip/export/consultation?month=${params.month}`

          break;
        case '会诊安排表':
          params.date = item.date;

          url = `/api/ip/export/consultationArrange?date=${params.date}`

          break;
        case '求医汇总':
          params.date = item.date;
          params.hospitalizationId = this.patient.curr.id;

          url = `/api/ip/export/seekmedical?hospitalizationId=${params.hospitalizationId}&date=${params.date}`

          break;
      }
      console.log(params)

      // 调用导出API
      this.loading = true;
      if (item.name == '交接班记录表') {
        api.getExcel(url, params).then(res => {
          let fileurl = `/api/store/attachment/${res.fileName}/file`
          api.downloadExcel(fileurl)
        }).finally(() => {
          this.loading = false;
        });
      } else {
        api.downloadExcel(url).then((res) => {
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
};
</script>

<style scoped>
.export-container {
  padding: 2rem;
}

.modules-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.module-card {
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 1.5rem;
}

.module-title {
  font-size: 1rem;
  color: #303133;
  text-align: center;
  margin-bottom: 1rem;
}

.module-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.export-link {
  color: #409eff;
  font-size: 0.875rem;
}

.export-link:hover {
  color: #66b1ff;
}
</style>
